<template>
  <div class="panel-body">
    <HeaderGeneral :vista="vista" :ruta="proveniente" :carpeta="carpeta" />
    
    <!-- Campo de búsqueda -->
    <b-row class="mb-3">
      <b-col md="6">
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>
              <b-icon icon="search"></b-icon>
            </b-input-group-text>
          </b-input-group-prepend>
          <b-form-input
            v-model="searchTerm"
            placeholder="Buscar por nombre, email o identificación..."
            type="text"
          ></b-form-input>
          <b-input-group-append v-if="searchTerm">
            <b-button variant="outline-secondary" @click="searchTerm = ''">
              <b-icon icon="x"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col md="6" class="text-right">
        <b-button @click="nuevo()" class="boton-busccar botonexcel">
          <b-icon class="iconoexcel" icon="person-plus" aria-hidden="true"></b-icon>Nuevo
        </b-button>
      </b-col>
    </b-row>

    <b-table responsive id="my-tablems"
            head-variant="light" striped :per-page="perPage" :current-page="currentPage" :items="filteredItems" :fields="fields">
            <template #cell(Estado)="row">
                <span
                    class="badge-estado"
                    :class="row.item.Estado === 'Activo' ? 'badge-activo' : 'badge-inactivo'">
                    {{ row.item.Estado }}
                </span>
            </template>
            <template #cell(estado)="row">
                <span class="badge-estado badge-texto">{{ row.item.estado || '-' }}</span>
            </template>
            <template #cell(Acciones)="row">
                <b-row class="acciones">
                    <b-col >

                        <b-button id="tooltip-target-1" variant="primary"
                            @click="datosUser(row.item.id, row.item,false)"><b-icon class="iconobuscar"
                                icon="eye-fill" /></b-button>

                        <b-tooltip target="tooltip-target-1" triggers="hover" placement="right">

                            Ver más

                        </b-tooltip>

                    </b-col>
                    <b-col >

                        <b-button  id="tooltip-target-2" variant="info"
                            @click="datosUser(row.item.id, row.item,true)"><b-icon class="iconobuscar"
                                icon="pencil-square" /></b-button>

                        <b-tooltip target="tooltip-target-2" triggers="hover">

                            Editar

                        </b-tooltip>

                    </b-col>
                    <b-col>
                        <b-button 
                            :id="'tooltip-target-status-' + row.index" 
                            :variant="row.item.Estado === 'Activo' ? 'warning' : 'success'"
                            @click="cambiarEstadoUsuario(row.item)">
                            <b-icon class="iconobuscar" 
                                :icon="row.item.Estado === 'Activo' ? 'toggle-on' : 'toggle-off'" />
                        </b-button>

                        <b-tooltip :target="'tooltip-target-status-' + row.index" triggers="hover">
                            {{ row.item.Estado === 'Activo' ? 'Desactivar' : 'Activar' }}
                        </b-tooltip>
                    </b-col>
                    <b-col>
                        <b-button
                            :id="'tooltip-target-estado-' + row.index"
                            variant="dark"
                            @click="abrirModalEstado(row.item)">
                            <b-icon class="iconobuscar" icon="tags-fill" />
                        </b-button>

                        <b-tooltip :target="'tooltip-target-estado-' + row.index" triggers="hover">
                            Cambiar estado
                        </b-tooltip>
                    </b-col>
                    <b-col>
                        <b-button
                            :id="'tooltip-target-password-' + row.index"
                            variant="secondary"
                            @click="abrirModalCambiarPassword(row.item)">
                            <b-icon class="iconobuscar" icon="key-fill" />
                        </b-button>

                        <b-tooltip :target="'tooltip-target-password-' + row.index" triggers="hover">
                            Cambiar contraseña
                        </b-tooltip>
                    </b-col>
                </b-row>
            </template>
        </b-table>
        <div class="spinerr" v-if="esperandoInfo == true">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <div class="divnodata" v-if="filteredItems.length == 0 && esperandoInfo != true">
            <b-img class="bannernodata" src="/img/banner.jpg"></b-img>
            <p v-if="searchTerm">No se encontraron resultados para "{{ searchTerm }}"</p>
            <p v-else>No se encontró información</p>
        </div>
        <b-row>
            <b-col class="nombrelabel" md="2" offset-md="9">
                <label for="selectPage">Registros por página:</label>
            </b-col>
            <b-col md="1">
                <b-form-select class="selectpage" @input="paginacion(currentPage = 1)" v-model="perPage"
                    :options="pageOptions" />
            </b-col>
        </b-row>
        <b-pagination class="justify-content-center" v-model="currentPage" :total-rows="rows" :per-page="perPage"
            @input="paginacion(currentPage)" aria-controls="my-tablems"></b-pagination>
    
    <!-- Modal para cambiar contraseña -->
    <b-modal 
      id="modal-cambiar-password" 
      v-model="showPasswordModal"
      title="Cambiar Contraseña"
      @hidden="resetPasswordForm"
      @ok="handlePasswordChange">
      <b-form @submit.stop.prevent="handlePasswordChange">
        <p class="text-muted mb-3">
          <strong>Usuario:</strong> {{ usuarioSeleccionado['P.Nombre'] }} {{ usuarioSeleccionado['P.Apellido'] }}<br>
          <strong>Email:</strong> {{ usuarioSeleccionado.Email }}
        </p>
        
        <b-form-group
          label="Nueva Contraseña"
          label-for="password-input"
          :state="passwordState">
          <b-form-input
            id="password-input"
            v-model="formPassword.password"
            type="password"
            placeholder="Ingrese nueva contraseña"
            :state="passwordState"
            required
          ></b-form-input>
          <b-form-invalid-feedback :state="passwordState">
            La contraseña debe tener al menos 6 caracteres
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          label="Confirmar Contraseña"
          label-for="confirm-password-input"
          :state="confirmPasswordState">
          <b-form-input
            id="confirm-password-input"
            v-model="formPassword.confirmPassword"
            type="password"
            placeholder="Confirme la contraseña"
            :state="confirmPasswordState"
            required
          ></b-form-input>
          <b-form-invalid-feedback :state="confirmPasswordState">
            Las contraseñas no coinciden
          </b-form-invalid-feedback>
        </b-form-group>
      </b-form>

      <template #modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button 
          variant="primary" 
          @click="ok()"
          :disabled="!isPasswordValid">
          Cambiar Contraseña
        </b-button>
      </template>
    </b-modal>

    <!-- Modal para cambiar el estado (texto) -->
    <b-modal
      id="modal-cambiar-estado"
      v-model="showEstadoModal"
      title="Cambiar estado"
      @hidden="resetEstadoForm"
      @ok="guardarEstado">
      <p class="text-muted mb-3" v-if="usuarioEstadoSeleccionado['P.Nombre']">
        <strong>Usuario:</strong> {{ usuarioEstadoSeleccionado['P.Nombre'] }} {{ usuarioEstadoSeleccionado['P.Apellido'] }}<br>
        <strong>Estado actual:</strong> {{ usuarioEstadoSeleccionado.estado || '-' }}
      </p>

      <b-form-group label="Estado" label-for="select-estado">
        <b-form-select
          id="select-estado"
          v-model="estadoSeleccionado"
          :options="estadoOptions">
          <template #first>
            <b-form-select-option :value="null" disabled>-- Seleccione --</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>

      <b-form-group label="¿No está la opción que necesitas? Agrégala:" label-for="nueva-opcion-estado">
        <b-input-group>
          <b-form-input
            id="nueva-opcion-estado"
            v-model="nuevaOpcionEstado"
            type="text"
            placeholder="Ej: En revisión, Suspendido..."
            @keydown.enter.prevent="agregarOpcionEstado"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              variant="outline-primary"
              @click="agregarOpcionEstado"
              :disabled="!nuevaOpcionEstado || !nuevaOpcionEstado.trim()">
              <b-icon icon="plus" /> Agregar
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <small class="text-muted">Se agrega a la lista y queda seleccionada.</small>
      </b-form-group>

      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancelar
        </b-button>
        <b-button
          variant="primary"
          @click="guardarEstado"
          :disabled="!estadoSeleccionado">
          Guardar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import Vue from 'vue'
import HeaderGeneral from "../../components/HeaderGeneral.vue";
import VueFormGenerator from 'vue-form-generator'
import 'vue-form-generator/dist/vfg.css'
import "vue-form-generator/dist/vfg-core.css";

Vue.use(VueFormGenerator)

const config = RepositoryFactory.get("config");
export default {
  components: {
    "vue-form-generator": VueFormGenerator.component,
    HeaderGeneral
  },
  data() {
    return {
      vista: "Usuarios",
      proveniente: " - Gestión de usuarios  ",
      carpeta: "Configuración",
      perPage: 5,
      pageOptions: [3, 5, 10, 15, 20],
      currentPage: 1,
      esperandoInfo: false,
      searchTerm: '',
      items:[],
      showPasswordModal: false,
      usuarioSeleccionado: {},
      formPassword: {
        password: '',
        confirmPassword: ''
      },
      showEstadoModal: false,
      nuevaOpcionEstado: '',
      estadoSeleccionado: null,
      usuarioEstadoSeleccionado: {},
      opcionesEstadoBase: ['Activo', 'Por aprobar', 'Bloqueado', 'Inactivo'],
      opcionesEstadoExtra: [],
      fields: [
                { key: 'T.Identificación', sortable: true },
                { key: 'N°Identificación', sortable: true },
                { key: 'NombreCompleto', label: 'Nombre completo', sortable: true },
                 { key: 'Celular', sortable: true },
                 {key: 'Email', sortable: true },
                 { key: 'Perfil', sortable: true },
                  { key: 'Estado', label: 'Activo', sortable: true },
                  { key: 'estado', label: 'Estado', sortable: true },
                   'Acciones'],
    }
  },
  mounted() {

    
  },
  computed: {
        filteredItems() {
            if (!this.searchTerm) {
                return this.items;
            }
            
            const search = this.searchTerm.toLowerCase().trim();
            
            return this.items.filter(item => {
                const nombreCompleto = `${item['P.Nombre'] || ''} ${item['S.Nombre'] || ''} ${item['P.Apellido'] || ''} ${item['S.Apellido'] || ''}`.toLowerCase();
                const email = (item.Email || '').toLowerCase();
                const identificacion = (item['N°Identificación'] || '').toString().toLowerCase();
                const tipoId = (item['T.Identificación'] || '').toLowerCase();
                const perfil = (item.Perfil || '').toLowerCase();
                
                return nombreCompleto.includes(search) ||
                       email.includes(search) ||
                       identificacion.includes(search) ||
                       tipoId.includes(search) ||
                       perfil.includes(search);
            });
        },
        rows() {
            return this.filteredItems.length
        },
        estadoOptions() {
            const existentes = this.items.map(i => i.estado).filter(Boolean);
            const todas = [
                ...this.opcionesEstadoBase,
                ...existentes,
                ...this.opcionesEstadoExtra
            ];
            // Quita duplicados conservando el orden
            return [...new Set(todas)];
        },
        passwordState() {
            return this.formPassword.password.length >= 6 ? true : this.formPassword.password.length === 0 ? null : false;
        },
        confirmPasswordState() {
            return this.formPassword.confirmPassword && 
                   this.formPassword.password === this.formPassword.confirmPassword ? true : 
                   this.formPassword.confirmPassword.length === 0 ? null : false;
        },
        isPasswordValid() {
            return this.formPassword.password.length >= 6 && 
                   this.formPassword.password === this.formPassword.confirmPassword;
        }
    },
  created() {
this.usuarios();

  },
  methods: {
   
    paginacion(currentPage) {
            this.currentPage = currentPage;
            this.usuarios();
        },
        nuevo(){
          this.$router.push("/registro");
        },
    async usuarios() {

        try {
          this.esperandoInfo = true;
          const response = await config.GetAllUser({ });
          this.esperandoInfo = false;
          this.items = response.map((x) => {
            // Convertir estado - puede venir como 1/0, "1"/"0", true/false, "Activo"/"Inactivo"
            let estadoTexto = 'Inactivo';
            if (x.activo === 1 || x.activo === '1' || x.activo === true || x.activo === 'Activo') {
              estadoTexto = 'Activo';
            }
            
            var dataa = {
              'id_usuario': x.id_usuario,
              'Estado': estadoTexto,
              'estado_numerico': x.activo,
              'Celular': x.celular,
              'estado': x.estado,
              'id_tipo_usuario': x.id_tipo_usuario,
              'Email': x.nombre_usuario,
              'N°Identificación': x.numero_id,
              'P.Apellido': x.primer_apellido,
              'P.Nombre': x.primer_nombre,
              'S.Apellido': x.segundo_apellido,
              'S.Nombre': x.segundo_nombre,
              'NombreCompleto': [x.primer_nombre, x.segundo_nombre, x.primer_apellido, x.segundo_apellido]
                .filter(Boolean).join(' '),
              'T.Identificación': x.tipo_id,
              'Perfil': x.descripcion_perfil || x.tipo_usuario || '-',
              'id_perfil': x.id_perfil || null,
              'id_proveedor': x.id_proveedor || null,
              'id_cliente': x.id_cliente || null,
            };
            return dataa;
          });
          console.log("this.items",this.items);
        } catch (error) {
          

        }
    },
    datosUser(id, datos,editar){
      var carpeta="Usuario";
      this.$router.push({ name: 'registro', params: { myParam: datos, id: id, editable: editar, carpeta: carpeta } });
    },
    async cambiarEstadoUsuario(usuario) {
      const nuevoEstado = usuario.Estado === 'Activo' ? 'Inactivo' : 'Activo';
      const accion = nuevoEstado === 'Activo' ? 'activar' : 'desactivar';
      
      this.$bvModal.msgBoxConfirm(
        `¿Está seguro que desea ${accion} al usuario ${usuario['P.Nombre']} ${usuario['P.Apellido']}?`,
        {
          title: 'Confirmar cambio de estado',
          size: 'md',
          buttonSize: 'sm',
          okVariant: nuevoEstado === 'Activo' ? 'success' : 'warning',
          okTitle: 'Sí, confirmar',
          cancelTitle: 'Cancelar',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )
      .then(async (value) => {
        if (value) {
          try {
            this.esperandoInfo = true;
            const response = await config.updateUserStatus({
              id_usuario: usuario.id_usuario,
              estado: nuevoEstado === 'Activo' ? 1 : 0
            });
            
            this.esperandoInfo = false;
            
            if (response) {
              this.$bvToast.toast(`Usuario ${accion} exitosamente`, {
                title: 'Éxito',
                variant: 'success',
                solid: true,
                autoHideDelay: 3000
              });
              
              // Recargar la lista de usuarios
              await this.usuarios();
            }
          } catch (error) {
            this.esperandoInfo = false;
            this.$bvToast.toast(`Error al ${accion} el usuario`, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 5000
            });
            console.error('Error al cambiar estado:', error);
          }
        }
      })
      .catch(err => {
        console.error('Error en modal:', err);
      });
    },
    async cambiarEstadoTexto(usuario, nuevoEstado) {
      if (!nuevoEstado || nuevoEstado === usuario.estado) {
        return;
      }
      const estadoAnterior = usuario.estado;
      try {
        this.esperandoInfo = true;
        const response = await config.updateUserEstado({
          id_usuario: usuario.id_usuario,
          estado: nuevoEstado
        });
        this.esperandoInfo = false;

        if (response) {
          usuario.estado = nuevoEstado;
          this.$bvToast.toast(`Estado actualizado a "${nuevoEstado}"`, {
            title: 'Éxito',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
        }
      } catch (error) {
        this.esperandoInfo = false;
        usuario.estado = estadoAnterior;
        this.$bvToast.toast('Error al actualizar el estado', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
        console.error('Error al cambiar estado (texto):', error);
      }
    },
    abrirModalEstado(usuario) {
      this.usuarioEstadoSeleccionado = usuario;
      this.estadoSeleccionado = usuario.estado || null;
      this.nuevaOpcionEstado = '';
      this.showEstadoModal = true;
    },
    resetEstadoForm() {
      this.nuevaOpcionEstado = '';
      this.estadoSeleccionado = null;
      this.usuarioEstadoSeleccionado = {};
    },
    agregarOpcionEstado() {
      const nueva = (this.nuevaOpcionEstado || '').trim();
      if (!nueva) {
        return;
      }
      if (!this.estadoOptions.includes(nueva)) {
        this.opcionesEstadoExtra.push(nueva);
      }
      this.estadoSeleccionado = nueva;
      this.nuevaOpcionEstado = '';
    },
    async guardarEstado(bvModalEvent) {
      if (bvModalEvent && bvModalEvent.preventDefault) {
        bvModalEvent.preventDefault();
      }
      if (!this.estadoSeleccionado) {
        this.$bvToast.toast('Seleccione un estado', {
          title: 'Error de validación',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }

      const usuario = this.usuarioEstadoSeleccionado;
      const nuevoEstado = this.estadoSeleccionado;
      this.showEstadoModal = false;
      if (usuario && usuario.id_usuario) {
        await this.cambiarEstadoTexto(usuario, nuevoEstado);
      }
    },
    abrirModalCambiarPassword(usuario) {
      this.usuarioSeleccionado = usuario;
      this.showPasswordModal = true;
    },
    resetPasswordForm() {
      this.formPassword = {
        password: '',
        confirmPassword: ''
      };
      this.usuarioSeleccionado = {};
    },
    async handlePasswordChange(bvModalEvent) {
      bvModalEvent.preventDefault();
      
      if (!this.isPasswordValid) {
        this.$bvToast.toast('Por favor ingrese una contraseña válida', {
          title: 'Error de validación',
          variant: 'warning',
          solid: true,
          autoHideDelay: 3000
        });
        return;
      }

      try {
        this.esperandoInfo = true;
        const response = await config.changeUserPassword({
          id_usuario: this.usuarioSeleccionado.id_usuario,
          password: this.formPassword.password
        });
        
        this.esperandoInfo = false;
        
        if (response) {
          this.$bvToast.toast('Contraseña cambiada exitosamente', {
            title: 'Éxito',
            variant: 'success',
            solid: true,
            autoHideDelay: 3000
          });
          
          this.showPasswordModal = false;
          this.resetPasswordForm();
        }
      } catch (error) {
        this.esperandoInfo = false;
        this.$bvToast.toast('Error al cambiar la contraseña', {
          title: 'Error',
          variant: 'danger',
          solid: true,
          autoHideDelay: 5000
        });
        console.error('Error al cambiar contraseña:', error);
      }
    },
  },
}
</script>
<style>
.fa,
.fas {
  font-family: 'Font Awesome 5 Free';
  font-weight: 900;
}

.form-group.disabled>label {
  color: #212529 !important;
  font-style: normal !important;
}

/* a continuación hay que poner la instrucción concreta de cada icono. fijaros que en realidad mediante el pseudo-selector ::before introducimos contenido delante de la etiqueta*/

.fa-thumbs-down:before {
  content: "\f165";
}

.nombre {
  transform: uppercase !important;
}

.alertared {
  margin-top: 2%;
}

.dele {
  color: white;
  background: var(--blue-violet);
  border-radius: 5px;
  zoom: 1.8;
  padding: 2%;
}

.hed {
  font-family: var(--font-family-poppins);

  padding: 1%;
  text-align: center;
}

.dato {
  border-top: 1px solid gainsboro;
}

.contenidotabla {
  background: white;
  margin: 0%;
  border-radius: 8px;
  border: 1px solid gainsboro;
  padding: 1%;
  margin-top: 3%;
}

.tabla {
  color: var(--blue-violet);
  font-weight: 600;
  border-bottom: 1px solid gainsboro;
}

.close {
  background: transparent;
  border: none;
  color: white;
  zoom: 1.5;
  margin-top: -0.6%;
  float: right;
}

.alert-dismissible {
  padding-right: 1rem !important;
}

.alert-danger {
  --bs-alert-color: white !important;
  --bs-alert-bg: red !important;
  --bs-alert-border-color: #f5c2c7;
  font-family: var(--font-family-poppins);
  font-size: 14px;
}

.icono {
  zoom: 2;
  margin-left: -32%;
  margin-top: -8%;

}

.vue-form-generator .hint {
  font-style: italic;
  font-size: 10px;
}

.has-error>.fiel-wrap {
  border: 1px solid red;
}

.errors {
  color: red;
  font-size: 11px !important;
}

.panel-body {
  margin: 2% 5%;
  font-family: var(--font-family-poppins);
}

.my-4 {
  color: var(--blue-violet);
}

.regis {
  font-size: 33px !important;
  text-align: center !important;
  font-weight: 600 !important;
  color: var(--blue-violet);
}

.centro {
  text-align: center;
}

hr {
  opacity: 1 !important;
}

.botonregidtro {
  width: 20%;
  margin-top: 2%;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
}

.botonadd {
  width: 50px;
  background-color: var(--blue-violet) !important;
  border-radius: 10px !important;
  height: 50px;
  border-color: transparent !important;
  border-color: transparent !important;
  position: absolute;
  right: 5%;
  top: 77%;
}

.badge-estado {
  font-size: 13px !important;
  padding: 6px 14px !important;
  font-weight: 500 !important;
  min-width: 75px;
  text-align: center;
  border-radius: 20px;
  display: inline-block;
  font-family: var(--font-family-poppins);
}

.badge-activo {
  background-color: #28a745 !important;
  color: white !important;
}

.badge-inactivo {
  background-color: #dc3545 !important;
  color: white !important;
}

.badge-texto {
  background-color: #6c757d !important;
  color: white !important;
}
</style>